import { IDBEntity } from '../../types/db';
import { dbService } from './db.service';

export abstract class BaseDBService<T extends IDBEntity> {
  protected db = dbService;
  protected abstract storeName: string;
  private initialized = false;

  async init(): Promise<void> {
    if (!this.initialized) {
      await this.db.init();
      this.initialized = true;
    }
  }

  async add(item: T): Promise<string> {
    await this.init();
    return (await this.db.add(this.storeName, item)) as string;
  }

  async update(item: T): Promise<string> {
    await this.init();
    return (await this.db.put(this.storeName, item)) as string;
  }

  async get(id: string): Promise<T | undefined> {
    await this.init();
    return (await this.db.get(this.storeName, id)) as T | undefined;
  }

  async getAll(): Promise<T[]> {
    await this.init();
    return (await this.db.getAll(this.storeName)) as T[];
  }

  async delete(id: string): Promise<boolean> {
    await this.init();
    return (await this.db.delete(this.storeName, id)) as boolean;
  }

  async clear(): Promise<boolean> {
    await this.init();
    return (await this.db.clear(this.storeName)) as boolean;
  }
}
